module.exports = __webpack_public_path__ + "static/img/bg.6d68502.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/default/bg.png
// module id = HVBc
// module chunks = 1